
import PicwishDemo from "@/components/picwishDemo";
import "@/styles/editPhoto.scss";
import { MessageBox } from "apower-ui";
          // window.installFramework = window.installFramework || Function.prototype
          installFramework(function(Vue) {
            
new Vue({
  components: {
    PicwishDemo,
  },
  data() {
    return {
      currentRouter: "beforeUpload",
    };
  },
  mounted() {
    this.bodyAddDragenter();
  },
  methods: {
    addFile(type) {
      this.$refs.demo.addFile(type);
    },
    bodyAddDragenter() {
      // 判断文件是否被拖拽进页面
      const bodyEl = document.querySelector("body");
      let _this = this;
      bodyEl.addEventListener("dragenter", function (e) {
        e.preventDefault();
        let appStatus = _this.$refs.demo.appStatus;
        if (
          e.dataTransfer.types[0] === "Files" &&
          appStatus !== "processing" &&
          appStatus !== "uploading"
        ) {
          _this.changeMast("flex");
        }
      });
    },
    fileDragover(e) {
      // 阻止默认Dragover事件 防止文件直接被浏览器打开
      e.preventDefault();
    },
    fileDragleave(e) {
      e.preventDefault();
      this.changeMast("none");
    },
    fileDrop(e) {
      e.preventDefault();
      const type = ["image/jpeg", "image/bmp", "image/png", "image/webp"];
      const file = e.dataTransfer.files[0];
      !!file &&
        (!!type.find((item) => item === file?.type) === true
          ? this.$refs.demo.onAddFileChange(file)
          : MessageBox.alert(this.$t("mesage.mask1"), this.$t("mesage.mask2"), {
              confirmButtonText: this.$t("mesage.mask3"),
              center: true,
              showClose: false,
              customClass: "mask_custom",
            }));
      this.changeMast("none");
    },
    changeMast(attribute) {
      const maskEl = document.querySelector(".mask");
      maskEl.style.display = attribute;
    },
  },
}).$mount("#app");

          })
        